import { render, staticRenderFns } from "./passengersInfo.vue?vue&type=template&id=7d9a0229&scoped=true"
import script from "./passengersInfo.vue?vue&type=script&lang=js"
export * from "./passengersInfo.vue?vue&type=script&lang=js"
import style0 from "./passengersInfo.vue?vue&type=style&index=0&id=7d9a0229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9a0229",
  null
  
)

export default component.exports